import { createSelector } from '@reduxjs/toolkit'
import type { RootState } from '@/store/store'
import { selectActiveContentViewerSession } from '@/content-viewer/store/selectors'
import { ViewerOpenContextKind } from '@/content-viewer/store/schemas'

// Stable fallback so components of unfetched conversations don't re-render on every store change
const kEmptyReferencesByCitationId: Record<string, never> = {}

export const selectAgentV2ReferencesByCitationId = (state: RootState, { conversationId }: { conversationId: string }) =>
  state.agentV2ReferencesState.referencesByConversationId[conversationId] ?? kEmptyReferencesByCitationId

/** The citation id whose source is open in the content viewer, for active-badge styling. */
export const selectAgentV2ActiveCitationId = createSelector(selectActiveContentViewerSession, (session) =>
  session?.context.kind === ViewerOpenContextKind.CHAT_CITATION ? session.context.citationId : null
)
